import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { ToolTypeDescriptionService, ToolDescriptionByTypeService, ToolTypeService } from '../../camtl.service';
import { ToolDesc } from '../../../../shared/model';

import { Observable } from 'rxjs/Rx';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { CgpGridComponent } from '../../../../shared/cgp-grid/cgp-grid.component';


@Component({
  selector: 'app-tool',
  templateUrl: './tool.component.html',
  // styleUrls: ['./tool.component.scss']
})
export class ToolComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private ToolTypeDescriptionService: ToolTypeDescriptionService,
    private ToolDescriptionByTypeService: ToolDescriptionByTypeService,
    private ToolTypeService: ToolTypeService,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,

  ) { }


  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;
  isNew: boolean = false;
  editDataItem: ToolDesc;
  ToolTypeId: any;
  editForm = this.formBuilder.group({
    Id: [],
    Name: ["", Validators.required],
    Description: ["", Validators.required],
    ToolTypeId: ["", Validators.required],
    CreatedDate: [],
    CreatedBy: [],
    IsActive: [false, Validators.required],
    ModifiedDate: [],
    ModifiedBy: [],
    AdditionalInfo: [],
  })



  columns: any[] = [
    {
      field: "Name",
      title: "Name",
    },

    {
      field: "Description",
      title: "Description",
    },
    // {
    //   field: "ToolTypeId",
    //   title: "ToolTypeId",
    // },
    {
      field: "IsActive",
      title: "Status",
      width: "125",
      template: {
        type: "boolean",
        onLabel: "Active",
        offLabel: "Inactive"
      }
    },
    {
      field: "AdditionalInfo",
      title: "Additional Info",

    }
  ]

  handleread = () => {

    var self = this;

    return this.ToolTypeService.read("", true).then(function (toolTypes: any) {
      self.ToolTypeId = toolTypes.filter(function (ToolType) {
        return ToolType.Description.toUpperCase() === "TOOL";
      })[0].Id;

      return self.ToolDescriptionByTypeService.read("/" + self.ToolTypeId + "/tooldescription", true).then(function (response: any[]) {

        return response;



      })
    })
  }

  onSave = (dataItem, isNew) => {
    var self = this;
    self.ToolTypeDescriptionService.save(dataItem, isNew, "", true, false)
      .then(function () {
        self.ToolTypeDescriptionService.loading.next(false);
        self.grid.refresh(true);
        self.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
      }).catch(function (response) {
        self.ToolTypeDescriptionService.loading.next(false);
        self.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
  }




  template = {

    controls: {
      add: true,
      edit: true,
      delete: false,
      excel: true,
      width: 65,
    },
    columns: this.columns,
    service: this.ToolTypeDescriptionService,
    read: this.handleread,
    save: this.onSave,
    fileName: 'CAMTL_tool_descriptions.xlsx'
  }

  formDialog = {
    title: "Tool",
    formControls: [
      {
        type: "text",
        name: "Name",
        title: "Name",
        readonly: "never",

      },
      {
        type: "text",
        name: "Description",
        title: "Description",
      },

      {
        type: "boolean",
        name: "IsActive",
        title: "IsActive",
        readonly: "never",
      },
      {
        type: "text",
        name: "AdditionalInfo",
        title: "Additional Info",
      }
    ],
  }


  public ngOnInit(): void {
    this.ToolTypeDescriptionService.query();
    this.ToolTypeService.query();
  }

  setModelHandler() {
    this.editDataItem = new ToolDesc();
    this.editDataItem.ToolTypeId = this.ToolTypeId;
    this.editDataItem.IsActive = false;
  }

}
